import Image from "next/image";
import clsx from "clsx";

interface Props {
  active: boolean;
  title: string;
  tag: string;
  icon: string;
  onClick: () => void;
}
export default function DropItem(props: Props) {
  const handleClick = () => {
    if (props.active) return;
    props.onClick();
  };
  return <>
    <div
      className="flex cursor-pointer items-center justify-between py-4"
      onClick={handleClick}
    >
      <div className="flex flex-1 items-center">
        <Image
          src={props.icon}
          width={24}
          height={24}
          alt="bot"
          style={{
            maxWidth: "100%",
            height: "auto"
          }} />

        <span className="ml-3  text-sm font-bold text-[#0E0E0E]">
          {props.title}
        </span>
      </div>

      <span
        className={clsx(
          "w-[60px] rounded-full py-0.5 text-center text-xs",
          props.active ? "bg-[#F9F4FF] text-primary" : "bg-F6F7F9 text-light"
        )}
      >
        {props.tag}
      </span>
    </div>
    <div className="h-[1px] w-full bg-F6F7F9"></div>
  </>;
}
